import { ProductSpecifications } from '@app/entities/Product/module/types/productSchema';
import { General } from '../types/filterSchema';

export const dataIdByName = {
  [ProductSpecifications.TyresWidth]: 'select-width',
  [ProductSpecifications.TyresProfile]: 'select-height',
  [ProductSpecifications.TyresDiameter]: 'select-radius',
  [ProductSpecifications.DiscsDiameter]: 'select-radius',
  [ProductSpecifications.DiscsPcd]: 'select-pcd',
  [ProductSpecifications.MinDiscsDia]: 'select-dia-min',
  [ProductSpecifications.MaxDiscsDia]: 'select-dia-max',
  [ProductSpecifications.MinDiscsEt]: 'select-et-min',
  [ProductSpecifications.MaxDiscsEt]: 'select-et-max',
  [ProductSpecifications.MinDiscsWidth]: 'select-width-min',
  [ProductSpecifications.MaxDiscsWidth]: 'select-width-max',

  priceMin: 'filter-price-min',
  priceMax: 'filter-price-max',

  [ProductSpecifications.TyresBSHM]: 'freetyres',
  [ProductSpecifications.TyresSaleFlag]: 'checkbox-sale',
  [ProductSpecifications.TyresHide4]: 'switch-hide-4',
  [ProductSpecifications.TyresIsCommercial]: 'checkbox-commerce',
  [ProductSpecifications.TyresRunFlat]: 'checkbox-runFlat',

  [General.ActionType]: 'select-actions-type',
  [General.GetAction]: 'select-actions',
  [General.GetShop]: 'select-shops',
  [General.StrictMode]: 'strict_mode',

  [ProductSpecifications.DiscsHide4]: 'switch-hide-4',
  [ProductSpecifications.DiscsSaleFlag]: 'checkbox-sale',
};

export enum ProductCategoryTabType {
  TYRES = 'tyres',
  WHEELS = 'wheels',
  BATTERIES = 'accumulators',
}

export const mapTabProductCategoryTabType: ProductCategoryTabType[] = [
  ProductCategoryTabType.TYRES,
  ProductCategoryTabType.WHEELS,
  ProductCategoryTabType.BATTERIES,
];

export enum FilterParams {
  Sort = 'sort',
  OrderSort = 'order',
  PageParam = 'page',

  MarkAuto = 'car_mark',
  ModelAuto = 'car_model',
  YearAuto = 'car_year',
  ModificationAuto = 'car_modification',
  ParamTab = 'car_active_tab',
  TyresSizeSparky = 'slaveId',

  StrictMode = 'strict_mode',
  Axis = 'axis',
}

export const arrayFilterSizeParams = [
  ProductSpecifications.TyresWidth,
  ProductSpecifications.TyresDiameter,
  ProductSpecifications.TyresProfile,
  ProductSpecifications.TyresDeveloper,
  ProductSpecifications.TyresSeason,
  ProductSpecifications.DiscsDiameter,
  ProductSpecifications.DiscsPcd,
  ProductSpecifications.DiscsDia,
  ProductSpecifications.DiscsEt,
  ProductSpecifications.DiscsWidth,
  ProductSpecifications.DiscsDeveloper,
  ProductSpecifications.AkbDeveloper,
  FilterParams.TyresSizeSparky,
];
